import { useState } from "react";
import BottomAppBar from "../components/BottomBar";
import Navigation from "../components/Navigation";
import { StarsTeam } from "../http/server-apis.js";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
// import Loader from "../components/loaders/loader";
import { Skeleton } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useSelector } from "react-redux";

const Team = () => {
  const [teamData, setTeamData] = useState([]);
  const teamLoaderArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { selectedLanguage } = useSelector((state) => state.Language);

  const { isLoading } = useQuery(
    ["get-stars-team"],
    () =>
      StarsTeam("get", {
        postfix: `?LangCode=${selectedLanguage}`,
      }),
    {
      onSuccess(data) {
        if (data?.status === 200)
          if (data.data.Status === "success") setTeamData(data.data.Team);
      },
    }
  );

  return (
    <>
      <Navigation title={"TEAM"} appBarColor="orange" />
      <div className="fixed-layout-main flex">
        <div className="white-card my-2">
          {isLoading ? (
            <>
              <p className="my-3">
                <Skeleton
                  sx={{ margin: "0 auto" }}
                  animation="wave"
                  variant="rectangular"
                  width={50}
                  height={20}
                />
              </p>
              <p className="mb-3">
                <Skeleton
                  sx={{ margin: "20px 0px" }}
                  animation="wave"
                  variant="rounded"
                  width={200}
                  height={10}
                />
              </p>
              <p>
                <Skeleton
                  sx={{ margin: "8px 0px", width: "100%" }}
                  animation="wave"
                  variant="rounded"
                  height={10}
                />
                <Skeleton
                  sx={{ margin: "8px 0px", width: "100%" }}
                  animation="wave"
                  variant="rounded"
                  height={10}
                />
                <Skeleton
                  sx={{ margin: "8px 0px", width: "100%" }}
                  animation="wave"
                  variant="rounded"
                  height={10}
                />
                <Skeleton
                  sx={{ margin: "8px 0px", width: "100%" }}
                  animation="wave"
                  variant="rounded"
                  height={10}
                />
                <Skeleton
                  sx={{ margin: "8px 0px", width: "100%" }}
                  animation="wave"
                  variant="rounded"
                  height={10}
                />
                <Skeleton
                  sx={{ margin: "8px 0px", width: "100%" }}
                  animation="wave"
                  variant="rounded"
                  height={10}
                />
                <Skeleton
                  sx={{ margin: "8px 0px", width: "100%" }}
                  animation="wave"
                  variant="rounded"
                  height={10}
                />
              </p>
              <div className="grid grid-cols-2 gap-2 ">
                {teamLoaderArray?.map((team) => {
                  return (
                    <div key={team} className="my-3">
                      <Skeleton
                        variant="circular"
                        width={120}
                        height={120}
                        sx={{ margin: "0 auto" }}
                      />
                      <p>
                        <Skeleton
                          sx={{ margin: "0 auto", marginTop: "5px" }}
                          animation="wave"
                          variant="rounded"
                          width={50}
                          height={8}
                        />
                        <Skeleton
                          sx={{ margin: "0 auto", marginTop: "5px" }}
                          animation="wave"
                          variant="rounded"
                          width={80}
                          height={8}
                        />
                      </p>
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <>
              <p className="text-center  text-secondary md:text-2xl my-3">{t("TEAM")}</p>
              <p className="text-black text-sm md:text-xl mb-3">
                Meet the Shining Stars Team
              </p>
              <p className=" text-sm text-justify font-light md:font-normal">
                Shining Stars Fostering Agency - A Family Feel Work Environment
              </p>
              <p className="text-sm text-justify font-light md:font-normal">
                At Shining Stars we are like a family working together towards
                our goals. supporting each other to combine individual strengths
                to enhance team performance and have a positive working
                atmosphere.
              </p>
              <div className="grid grid-cols-2 gap-2 ">
                {teamData?.map((team) => {
                  return (
                    <div
                      key={team.Image}
                      className="my-3"
                      onClick={() => navigate(`/team/${team.TeamID}`)}
                    >
                      <img
                        src={team.Image}
                        alt={team.Image}
                        className="rounded-full mx-auto overflow-hidden w-32 h-32 object-cover "
                      />

                      <p className=" text-xs text-center md:text-base mt-2">{team.Name}</p>
                      <p className="text-xs md:text-sm  md:font-normal font-light text-center text-gray-400 ">
                        {team.Designation}
                      </p>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>
      <BottomAppBar />
    </>
  );
};

export default Team;
